import React, { useContext } from 'react';

import { AppContext } from '@prisjakt/ui-app-context';

import { FontEmphasis } from '@prisjakt/ui/text';
import { CaptionText } from '@prisjakt/ui/text/variants';

import { MediumUp, MobileOnly } from 'src/ui/block';
import { usePriceRowContext } from '../../../price-row-context';

import {
  ShippingType,
  isStockStatusSupported,
  getShippingDays,
  getStandardizedDeliveryText,
  StockStatusEnum,
} from './utils';

import { ShippingCollection, StockStatus } from 'src/types';

import { StyledCaptionText, StyledDeliveryTime } from './styles';
import { OptionTypeEnum } from 'src/components/filter-dropdown';

interface IDeliveryTimeProps {
  shipping?: ShippingCollection | null;
  stockStatus?: StockStatus | null;
}

export const DeliveryTime = (props: IDeliveryTimeProps) => {
  const { shipping, stockStatus } = props;

  const { t } = useContext(AppContext);

  const { forceMobileView, sorting } = usePriceRowContext();

  let sort = ShippingType.CHEAPEST;

  if (sorting === OptionTypeEnum.FASTEST_DELIVERY) {
    sort = ShippingType.FASTEST;
  }

  const label =
    stockStatus === StockStatusEnum.IN_STOCK ||
    stockStatus === StockStatusEnum.INCOMING
      ? `${t('product', 'delivery-time.label')}: `
      : '';
  const shippingDays = getShippingDays(t, sort, shipping);
  const standardizedDeliveryText = getStandardizedDeliveryText(t, stockStatus);
  const deliveryTimeShort = isStockStatusSupported(stockStatus) && shippingDays;
  const hasFastestDeliveryDays = shipping?.fastest?.deliveryDays;
  const deliveryTimeLong =
    label + (deliveryTimeShort ? shippingDays : standardizedDeliveryText);

  const renderDeliveryTime = () => {
    if (!hasFastestDeliveryDays && sort !== ShippingType.FASTEST) {
      return null;
    }

    return (
      <MobileOnly>
        <CaptionText emphasis={FontEmphasis.MEDIUM}>
          <span>{deliveryTimeShort}</span>
        </CaptionText>
      </MobileOnly>
    );
  };

  return (
    <StyledDeliveryTime>
      {renderDeliveryTime()}
      {!forceMobileView && deliveryTimeLong && (
        <MediumUp>
          <StyledCaptionText emphasis={FontEmphasis.MEDIUM}>
            <span>{deliveryTimeLong}</span>
          </StyledCaptionText>
        </MediumUp>
      )}
    </StyledDeliveryTime>
  );
};
